export default function App() {
  const services = [
    "TikTok Style Videos",
    "Product Demonstrations",
    "Voiceover Reviews",
    "Lifestyle Content",
    "Beauty & Wellness Videos",
    "UGC Testimonials",
    "Unboxings & Aesthetic B-Roll",
    "Family, Pet & Everyday Routine Content",
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#fffaf7",
        color: "#2f2f2f",
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Playfair+Display:wght@600;700&display=swap');
      `}</style>

      {/* HERO */}
      <section
        style={{
          padding: "100px 24px 90px",
          background:
            "linear-gradient(135deg, #e7f7f4 0%, #fffaf7 48%, #fdecef 100%)",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "56px",
            alignItems: "center",
          }}
        >
          <div>
            <p
              style={{
                textTransform: "uppercase",
                letterSpacing: "4px",
                color: "#3f8f87",
                marginBottom: "18px",
                fontWeight: 700,
                fontSize: "14px",
              }}
            >
              Created By Heidi • UGC Creator
            </p>

            <h1
              style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: "clamp(48px, 7vw, 82px)",
                lineHeight: 1.02,
                marginBottom: "26px",
                color: "#242424",
              }}
            >
              Authentic content with a soft, relatable touch.
            </h1>

            <p
              style={{
                fontSize: "21px",
                lineHeight: 1.75,
                marginBottom: "38px",
                maxWidth: "650px",
                color: "#555",
              }}
            >
              I create polished, natural UGC videos for brands that want to feel
              trustworthy, approachable, and real. Perfect for TikTok, Instagram
              Reels, YouTube Shorts, and paid ads.
            </p>

            <div
              style={{
                display: "flex",
                gap: "16px",
                flexWrap: "wrap",
              }}
            >
              <a
                href="mailto:heidijovanovic@createdbyheidi.com?subject=UGC%20Collaboration%20Inquiry"
                style={{
                  padding: "16px 32px",
                  borderRadius: "999px",
                  border: "none",
                  background: "#3f8f87",
                  color: "white",
                  fontSize: "17px",
                  fontWeight: 700,
                  cursor: "pointer",
                  boxShadow: "0 12px 26px rgba(63,143,135,0.28)",
                  textDecoration: "none",
                }}
              >
                Work With Me
              </a>

              <a
                href="#portfolio"
                style={{
                  padding: "16px 32px",
                  borderRadius: "999px",
                  border: "1px solid #e7d8d1",
                  background: "rgba(255,255,255,0.72)",
                  color: "#3d3d3d",
                  fontSize: "17px",
                  fontWeight: 600,
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              >
                View Portfolio
              </a>
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.72)",
              borderRadius: "40px",
              padding: "18px",
              boxShadow: "0 24px 60px rgba(86,67,55,0.12)",
              border: "1px solid rgba(255,255,255,0.8)",
            }}
          >
            <img
              src="https://drive.google.com/thumbnail?id=12sDMDv2hcQDMBlcRVDSjIv40ZlYSal7Z&sz=w1000"
              alt="Heidi, UGC creator"
              style={{
                width: "100%",
                height: "620px",
                objectFit: "cover",
                borderRadius: "30px",
              }}
            />
          </div>
        </div>
      </section>

      {/* BRAND STRIP */}
      <section
        style={{
          padding: "24px",
          background: "#ffffff",
          borderTop: "1px solid #f1e4df",
          borderBottom: "1px solid #f1e4df",
        }}
      >
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            gap: "28px",
            flexWrap: "wrap",
            color: "#74655f",
            fontWeight: 600,
          }}
        >
          <span>UGC Videos</span>
          <span>•</span>
          <span>Lifestyle Content</span>
          <span>•</span>
          <span>Product Storytelling</span>
          <span>•</span>
          <span>Voiceovers</span>
        </div>
      </section>

      {/* ABOUT */}
      <section style={{ padding: "100px 24px" }}>
        <div
          style={{
            maxWidth: "1150px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "56px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              borderRadius: "36px",
              padding: "16px",
              boxShadow: "0 18px 45px rgba(86,67,55,0.08)",
            }}
          >
            <img
              src="https://drive.google.com/thumbnail?id=1FFODxXhauBLVc2W6y4MEL1O6PEg6VJi2&sz=w1000"
              alt="Behind the scenes lifestyle creator"
              style={{
                width: "100%",
                height: "520px",
                objectFit: "cover",
                borderRadius: "28px",
              }}
            />
          </div>

          <div>
            <p
              style={{
                textTransform: "uppercase",
                letterSpacing: "4px",
                color: "#3f8f87",
                marginBottom: "16px",
                fontWeight: 700,
                fontSize: "14px",
              }}
            >
              About The Creator
            </p>

            <h2
              style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: "clamp(42px, 5vw, 60px)",
                marginBottom: "24px",
                color: "#242424",
              }}
            >
              Hi, I’m Heidi.
            </h2>

            <p
              style={{
                fontSize: "19px",
                lineHeight: 1.85,
                marginBottom: "30px",
                color: "#555",
              }}
            >
              I’m a 43-year-old UGC creator based near Niagara Falls, New York.
              I create warm, authentic, brand-friendly content with a soft
              feminine style and a relatable real-life perspective.
            </p>

            <div
              style={{
                display: "grid",
                gap: "14px",
                fontSize: "17px",
                color: "#3f3f3f",
              }}
            >
              <div>✓ Slim athletic build with a lifestyle-friendly look</div>
              <div>✓ Mom of humans, a cat, and a dog</div>
              <div>✓ Comfortable on camera and with voiceovers</div>
              <div>✓ Natural product storytelling and aesthetic B-roll</div>
              <div>
                ✓ Content for TikTok, Instagram Reels, YouTube Shorts & ads
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTENT TYPES */}
      <section
        style={{
          padding: "100px 24px",
          background: "#f7f3ef",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "54px" }}>
            <p
              style={{
                textTransform: "uppercase",
                letterSpacing: "4px",
                color: "#3f8f87",
                fontWeight: 700,
                marginBottom: "14px",
                fontSize: "14px",
              }}
            >
              Content Services
            </p>

            <h2
              style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: "clamp(42px, 5vw, 62px)",
                color: "#242424",
              }}
            >
              Types of UGC I Create
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "24px",
            }}
          >
            {services.map((service) => (
              <div
                key={service}
                style={{
                  background: "rgba(255,255,255,0.82)",
                  borderRadius: "28px",
                  padding: "30px",
                  boxShadow: "0 12px 30px rgba(86,67,55,0.07)",
                  border: "1px solid rgba(255,255,255,0.9)",
                }}
              >
                <h3
                  style={{
                    fontSize: "21px",
                    lineHeight: 1.5,
                    color: "#343434",
                  }}
                >
                  {service}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHAT I BRING */}
      <section
        style={{
          padding: "100px 24px",
          background: "#fffdfb",
        }}
      >
        <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "56px" }}>
            <p
              style={{
                textTransform: "uppercase",
                letterSpacing: "4px",
                color: "#3f8f87",
                fontWeight: 700,
                marginBottom: "14px",
                fontSize: "14px",
              }}
            >
              What I Bring To Your Brand
            </p>

            <h2
              style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: "clamp(42px, 5vw, 62px)",
                color: "#242424",
                marginBottom: "20px",
              }}
            >
              Content that feels authentic, polished & relatable.
            </h2>

            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                fontSize: "19px",
                lineHeight: 1.8,
                color: "#5c5c5c",
              }}
            >
              I create warm, natural content designed to help brands connect
              with everyday consumers through relatable storytelling and clean,
              aesthetically pleasing visuals.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "24px",
            }}
          >
            {[
              "Authentic relatable on-camera presence",
              "Soft feminine lifestyle aesthetic",
              "Natural product storytelling",
              "Comfortable with voiceovers and talking videos",
              "Clean polished editing style",
              "Real-life family & wellness perspective",
              "Short-form content optimized for TikTok & Reels",
              "Fast communication and attention to detail",
            ].map((item) => (
              <div
                key={item}
                style={{
                  background: "rgba(255,255,255,0.92)",
                  borderRadius: "30px",
                  padding: "34px 28px",
                  boxShadow: "0 14px 34px rgba(86,67,55,0.08)",
                  border: "1px solid #f1e4df",
                }}
              >
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "50%",
                    background: "#dff4ef",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "22px",
                    fontSize: "22px",
                  }}
                >
                  ✦
                </div>

                <h3
                  style={{
                    fontSize: "21px",
                    lineHeight: 1.6,
                    color: "#343434",
                    fontWeight: 600,
                  }}
                >
                  {item}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PORTFOLIO */}
      <section id="portfolio" style={{ padding: "100px 24px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "54px" }}>
            <p
              style={{
                textTransform: "uppercase",
                letterSpacing: "4px",
                color: "#3f8f87",
                fontWeight: 700,
                marginBottom: "14px",
                fontSize: "14px",
              }}
            >
              Portfolio
            </p>

            <h2
              style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                fontSize: "clamp(42px, 5vw, 62px)",
                color: "#242424",
              }}
            >
              Featured Video Projects
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "30px",
            }}
          >
            {/* PRODUCT DEMO */}
            <div
              style={{
                background: "#ffffff",
                borderRadius: "34px",
                overflow: "hidden",
                boxShadow: "0 18px 48px rgba(86,67,55,0.1)",
                padding: "14px",
              }}
            >
              <div
  style={{
    position: "relative",
    cursor: "pointer",
  }}
  onClick={() => {
  const video = document.getElementById("product-demo-video") as HTMLVideoElement;
  const button = document.getElementById("product-demo-play-button");

  if (video) {
    video.play();
    video.controls = true;
  }

  if (button) {
    button.style.display = "none";
  }
}}
>
  <video
    id="product-demo-video"
    onEnded={(e) => {
  e.currentTarget.load();
e.currentTarget.controls = false;
  const button = document.getElementById("product-demo-play-button");

  if (button) {
    button.style.display = "flex";
  }
}}
    poster="https://drive.google.com/thumbnail?id=1Q2xpTZVghviCIgsyBBvjlUsmc6G_pDQR&sz=w1000"
    style={{
      width: "100%",
      height: "500px",
      objectFit: "cover",
      borderRadius: "26px",
      backgroundColor: "#000",
    }}
  >
    <source src="/product-demo.mp4" type="video/mp4" />
  </video>

<div
  id="product-demo-play-button"
  style={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "82px",
    height: "82px",
    background: "rgba(63,143,135,0.62)",
    borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 14px 34px rgba(0,0,0,0.22)",
      backdropFilter: "blur(10px)",
    }}
  >
    <div
  style={{
    color: "white",
    fontSize: "34px",
    marginLeft: "6px",
  }}
>
  ▶
</div>
  </div>
</div>
              <div style={{ padding: "26px 14px 12px" }}>
                <h3
                  style={{
                    fontFamily: '"Playfair Display", Georgia, serif',
                    fontSize: "28px",
                    marginBottom: "12px",
                    color: "#242424",
                  }}
                >
                  Product Demo
                </h3>

                <p
                  style={{
                    lineHeight: 1.75,
                    fontSize: "16.5px",
                    color: "#5c5c5c",
                  }}
                >
                  Natural product-focused UGC with soft lifestyle visuals and
                  authentic storytelling.
                </p>
              </div>
            </div>

            {/* LIFESTYLE AD */}
            <div
              style={{
                background: "#ffffff",
                borderRadius: "34px",
                overflow: "hidden",
                boxShadow: "0 18px 48px rgba(86,67,55,0.1)",
                padding: "14px",
              }}
            >
              <div
  style={{
    position: "relative",
    cursor: "pointer",
  }}
  onClick={() => {
    const video = document.getElementById("lifestyle-video") as HTMLVideoElement;
    const button = document.getElementById("lifestyle-play-button");

    if (video) {
      video.play();
      video.controls = true;
    }

    if (button) {
      button.style.display = "none";
    }
  }}
>
  <video
    id="lifestyle-video"
    onEnded={(e) => {
      e.currentTarget.load();
      e.currentTarget.controls = false;

      const button = document.getElementById("lifestyle-play-button");

      if (button) {
        button.style.display = "flex";
      }
    }}
    poster="https://drive.google.com/thumbnail?id=1erKIpz1plrpHVkb0YsbJphyXbzY1SZql&sz=w1000"
    style={{
      width: "100%",
      height: "500px",
      objectFit: "cover",
      borderRadius: "26px",
      backgroundColor: "#000",
    }}
  >
    <source src="/lifestyle-ad.mp4" type="video/mp4" />
  </video>

  <div
    id="lifestyle-play-button"
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "82px",
      height: "82px",
      background: "rgba(63,143,135,0.62)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 14px 34px rgba(0,0,0,0.22)",
      backdropFilter: "blur(10px)",
    }}
  >
    <div
      style={{
        color: "white",
        fontSize: "34px",
        marginLeft: "6px",
      }}
    >
      ▶
    </div>
  </div>
</div>

              <div style={{ padding: "26px 14px 12px" }}>
                <h3
                  style={{
                    fontFamily: '"Playfair Display", Georgia, serif',
                    fontSize: "28px",
                    marginBottom: "12px",
                    color: "#242424",
                  }}
                >
                  Lifestyle Ad
                </h3>

                <p
                  style={{
                    lineHeight: 1.75,
                    fontSize: "16.5px",
                    color: "#5c5c5c",
                  }}
                >
                  Warm lifestyle-focused content designed to feel relatable,
                  polished, and brand friendly.
                </p>
              </div>
            </div>

            {/* VOICEOVER REVIEW */}
            <div
              style={{
                background: "#ffffff",
                borderRadius: "34px",
                overflow: "hidden",
                boxShadow: "0 18px 48px rgba(86,67,55,0.1)",
                padding: "14px",
              }}
            >
              <div
  style={{
    position: "relative",
    cursor: "pointer",
  }}
  onClick={() => {
    const video = document.getElementById("voiceover-video") as HTMLVideoElement;
    const button = document.getElementById("voiceover-play-button");

    if (video) {
      video.play();
      video.controls = true;
    }

    if (button) {
      button.style.display = "none";
    }
  }}
>
  <video
    id="voiceover-video"
    onEnded={(e) => {
      e.currentTarget.load();
      e.currentTarget.controls = false;

      const button = document.getElementById("voiceover-play-button");

      if (button) {
        button.style.display = "flex";
      }
    }}
    poster="https://drive.google.com/thumbnail?id=1Dgs0EfKTpnW3eHby6vJiEPcOb-nzGsaK&sz=w1000"
    style={{
      width: "100%",
      height: "500px",
      objectFit: "cover",
      borderRadius: "26px",
      backgroundColor: "#000",
    }}
  >
    <source src="/voiceover-review.mp4" type="video/mp4" />
  </video>

  <div
    id="voiceover-play-button"
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "82px",
      height: "82px",
      background: "rgba(63,143,135,0.62)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 14px 34px rgba(0,0,0,0.22)",
      backdropFilter: "blur(10px)",
    }}
  >
    <div
      style={{
        color: "white",
        fontSize: "34px",
        marginLeft: "6px",
      }}
    >
      ▶
    </div>
  </div>
</div>

              <div style={{ padding: "26px 14px 12px" }}>
                <h3
                  style={{
                    fontFamily: '"Playfair Display", Georgia, serif',
                    fontSize: "28px",
                    marginBottom: "12px",
                    color: "#242424",
                  }}
                >
                  Voiceover Review
                </h3>

                <p
                  style={{
                    lineHeight: 1.75,
                    fontSize: "16.5px",
                    color: "#5c5c5c",
                  }}
                >
                  Conversational UGC with authentic voiceover delivery and a
                  clean feminine aesthetic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      
{/* RATE SHEET INQUIRY */}
<section
  style={{
    padding: "100px 24px",
    background: "#fffdfb",
  }}
>
  <div
    style={{
      maxWidth: "950px",
      margin: "0 auto",
      textAlign: "center",
      background: "linear-gradient(135deg, #e7f7f4 0%, #fffaf7 55%, #fdecef 100%)",
      borderRadius: "38px",
      padding: "64px 34px",
      boxShadow: "0 22px 55px rgba(86,67,55,0.1)",
      border: "1px solid #f1e4df",
    }}
  >
    <p
      style={{
        textTransform: "uppercase",
        letterSpacing: "4px",
        color: "#3f8f87",
        fontWeight: 700,
        marginBottom: "14px",
        fontSize: "14px",
      }}
    >
      Packages Available Upon Request
    </p>

    <h2
      style={{
        fontFamily: '"Playfair Display", Georgia, serif',
        fontSize: "clamp(40px, 5vw, 60px)",
        color: "#242424",
        marginBottom: "22px",
      }}
    >
      Interested in working together?
    </h2>

    <p
      style={{
        maxWidth: "720px",
        margin: "0 auto 34px auto",
        fontSize: "19px",
        lineHeight: 1.8,
        color: "#5c5c5c",
      }}
    >
      I’d love to learn more about your brand, campaign goals, and content needs.
      Please email me to request my current UGC package details, availability,
      and custom rate sheet.
    </p>

    <a
      href="mailto:heidijovanovic@createdbyheidi.com?subject=UGC%20Rate%20Sheet%20Inquiry&body=Hi%20Heidi%2C%0A%0AI%E2%80%99d%20love%20to%20learn%20more%20about%20your%20UGC%20packages%20and%20current%20availability.%0A%0ABrand%20Name%3A%0AProject%20Type%3A%0ATimeline%3A%0AContent%20Needed%3A%0A%0AThank%20you!"
      style={{
        display: "inline-block",
        padding: "18px 40px",
        borderRadius: "999px",
        border: "none",
        background: "#3f8f87",
        color: "white",
        fontSize: "18px",
        fontWeight: 800,
        cursor: "pointer",
        boxShadow: "0 12px 30px rgba(63,143,135,0.25)",
        textDecoration: "none",
      }}
    >
      Request My Rate Sheet
    </a>
  </div>
</section>
      {/* CONTACT */}
      <section
        style={{
          padding: "105px 24px",
          background: "linear-gradient(135deg, #3f8f87 0%, #2f706b 100%)",
          color: "white",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            fontSize: "clamp(44px, 6vw, 68px)",
            marginBottom: "24px",
          }}
        >
          Let’s Create Together
        </h2>

        <p
          style={{
            fontSize: "21px",
            maxWidth: "800px",
            margin: "0 auto 42px auto",
            lineHeight: 1.75,
            color: "#effffb",
          }}
        >
          Available for brand collaborations, sponsored content, product
          showcases, testimonials, and lifestyle-focused UGC campaigns.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "18px",
            flexWrap: "wrap",
            marginBottom: "34px",
          }}
        >
          <a
            href="https://www.tiktok.com/@created.by.heidi"
            target="_blank"
            rel="noreferrer"
            aria-label="TikTok"
            style={{
              width: "58px",
              height: "58px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.18)",
              color: "white",
              textDecoration: "none",
              fontWeight: 800,
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid rgba(255,255,255,0.32)",
              boxShadow: "0 12px 30px rgba(0,0,0,0.14)",
              backdropFilter: "blur(10px)",
            }}
          >
            ♪
          </a>
          <a
            href="https://www.instagram.com/created.by.heidi.ugc"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            style={{
              width: "58px",
              height: "58px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.18)",
              color: "white",
              textDecoration: "none",
              fontWeight: 800,
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid rgba(255,255,255,0.32)",
              boxShadow: "0 12px 30px rgba(0,0,0,0.14)",
              backdropFilter: "blur(10px)",
            }}
          >
            ◎
          </a>
          <a
            href="https://x.com/_createdbyheidi"
            target="_blank"
            rel="noreferrer"
            aria-label="X"
            style={{
              width: "58px",
              height: "58px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.18)",
              color: "white",
              textDecoration: "none",
              fontWeight: 800,
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid rgba(255,255,255,0.32)",
              boxShadow: "0 12px 30px rgba(0,0,0,0.14)",
              backdropFilter: "blur(10px)",
            }}
          >
            X
          </a>
        </div>

        <p style={{ marginBottom: "32px", fontSize: "18px", color: "#effffb" }}>
          heidijovanovic@createdbyheidi.com
        </p>

        <a
          href="mailto:heidijovanovic@createdbyheidi.com?subject=UGC%20Collaboration%20Inquiry"
          style={{
            display: "inline-block",
            padding: "18px 40px",
            borderRadius: "999px",
            border: "none",
            background: "white",
            color: "#2f706b",
            fontSize: "19px",
            fontWeight: 800,
            cursor: "pointer",
            boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
            textDecoration: "none",
          }}
        >
          Contact Me
        </a>
      </section>
    </div>
  );
}
